var Rule = /** @class */ (function () {
    function Rule($el, query) {
        if (query === void 0) { query = null; }
        this.$el = $el;
        this.query = query;
        if (!this.query) {
            this.query = AdminColumns.Search.query;
        }
    }
    Rule.prototype.getID = function () {
        return this.$el.attr('id');
    };
    Rule.prototype.getIndex = function () {
        var id = this.getID();
        return id.replace('ac-s_rule_', '');
    };
    Rule.prototype.getRule = function () {
        return this.query.getRule(this.getIndex());
    };
    Rule.prototype.getFilterID = function () {
        return this.$el.find('.rule-filter-container select').val();
    };
    Rule.prototype.getFilter = function () {
        var id = this.getFilterID();
        if (!id) {
            return null;
        }
        return this.query.getFilter(id);
    };
    Rule.prototype.getOperator = function () {
        return this.$el.find('.rule-operator-container select').val();
    };
    Rule.prototype.open = function () {
        var $el = this.$el;
        $el.removeClass('compact');
        $el.find('.rule-filter-container, .rule-operator-container, .rule-value-container, .rule-header [data-confirm]').show();
        if (AdminColumns.Search.defaults.operators.nullable.includes(this.getOperator())) {
            $el.find('.rule-value-container').hide();
        }
    };
    Rule.prototype.compact = function () {
        var $el = this.$el;
        this.updateDisplay($el);
        $el.addClass('compact');
        $el.find('.rule-filter-container, .rule-operator-container, .rule-value-container, .rule-header [data-confirm]').hide();
    };
    /**
     * Updates the human readable display for a collapsed filter
     *
     * @param $el
     */
    Rule.prototype.updateDisplay = function ($el) {
        var self = this;
        if (0 === $el.find('.rule-display').length) {
            $el.prepend('<div class="rule-display"></div>');
        }
        var $filter = $el.find('.rule-filter-container select option:selected');
        var $operator = $el.find('.rule-operator-container select option:selected');
        var $value_input = $el.find('.rule-value-container input[name], .rule-value-container select[name]');
        var value;
        if (1 === $value_input.length) {
            value = self.alterDisplayValue($value_input.val());
            if ($value_input.is('select')) {
                value = $value_input.find('option:selected').text();
            }
        }
        else {
            var values_1 = [];
            jQuery.each($value_input, function (k, value) {
                values_1.push(self.alterDisplayValue(jQuery(value).val()));
            });
            value = values_1.join(' - ');
        }
        // No value if nullable
        if (AdminColumns.Search.defaults.operators.nullable.includes($operator.val())) {
            value = '';
        }
        // Sanitize and don't allow HTML tags to prevent XSS issues
        value = jQuery("<div>" + value + "</div>").text();
        var string = "<span class=\"rule-display__filter\">" + $filter.data('label') + "</span>\n\t\t\t\t\t\t<span class=\"rule-display__operator\">" + $operator.text() + "</span>\n\t\t\t\t\t\t<span class=\"rule-display__value\">" + value + "</span>";
        $el.find('.rule-display').html(string);
    };
    Rule.prototype.alterDisplayValue = function (value) {
        var filter_type = AdminColumns.Search.filtertypes.getType(this.getFilter().filter_type);
        if (filter_type && filter_type.hasOwnProperty('ruleDisplayValue')) {
            value = filter_type.ruleDisplayValue(value, this);
        }
        return value;
    };
    return Rule;
}());
export default Rule;
